import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';

export const useCommonCardPointsBalance = () => {
  const { currentUser } = useCurrentUserContext();
  const balance = currentUser?.commonCardPoints || 0;

  const commonCardsCount = currentUser?.cardCounts?.common || 0;

  return {
    commonCardPointsBalance: balance,
    commonCardsCount,
  };
};
